export const SET_ACTIVE_ROOM = 'SET_ACTIVE_ROOM'
export const RESET_ACTIVE_ROOM = 'RESET_ACTIVE_ROOM'

export const selectedRoom = activeRoom => ({
	type: SET_ACTIVE_ROOM,
	payload: activeRoom
})
export const resetRoom = () => ({
	type: RESET_ACTIVE_ROOM
})

export default function setActiveRoom(activeRoom) {
	return dispatch => {
		dispatch(selectedRoom(activeRoom))
	}
}

export function resetActiveRoom() {
	return dispatch => {
		dispatch(resetRoom())
	}
}



// WEBPACK FOOTER //
// ./src/actions/setActiveRoomActions.js